import tw from 'twin.macro';

const contentSizeStyle = {
  sm: tw`mt-4 mr-6 mb-6 ml-6`,
  lg: tw`mt-6 mr-8 mb-8 ml-8`,
};

const styles = {
  // eslint-disable-next-line no-shadow -- FIXME
  header: ({ styles }) => [
    tw`flex justify-between items-center sticky top-0 bg-white z-50 border-b border-gray-1 pl-6 pr-4 py-4`,
    styles,
  ],
  content: ({ size }) => [contentSizeStyle[size]],
  footer: fixed => [
    tw`px-6 pt-5 pb-8.5 sm:pb-5 bg-white`,
    fixed && tw`sticky bottom-0 border-t border-gray-1`,
  ],
};

export default styles;
